import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Container, Divider, Grid, InputLabel, makeStyles, Typography } from "@material-ui/core";

import { PAGES } from "..";
import { LogoText } from "../../components/logoText";
import { FooterReset } from "../../components/footerReset";
import { TextInput } from "../../components/base/TextInput";
import { Button, TextButton } from "../../components/base/Button";
import lockIcon from "../../assets/images/icons/lock.png";
import ResetPasswordImg from "../../assets/images/Registration/bottom_illustration.svg";
import {
  api,
  ATLEAST_ONE_UPPERCASE,
  MAX_PASS_CHAR_COUNT,
  MIN_PASS_CHAR_COUNT,
  SPECIAL_CHARACTER,
} from "../../services";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  logo: {
    padding: theme.spacing(5),
    textAlign: "center",
  },
  title: {
    marginTop: theme.spacing(12),
    marginBottom: theme.spacing(6),
    fontSize: "36px",
  },
  youremail: {
    marginLeft: "15%",
  },
  input: {
    width: "70%",
  },
  inputLabel: {
    fontSize: "14px",
    alignSelf: "left",
  },
  groupBtn: {
    marginTop: theme.spacing(6),
  },
  resetImgstyle: {
    display: "flex",
    justifyContent: "center",
    position: "relative",
    top: "107px",
    marginTop: "-65px",
  },
  passwordwithforget: {
    display: "flex",
    alignItems: "center",
    "& .makeStyles-root-12": {
      "& .MuiGrid-container": {
        width: "395px",
        marginRight: "-40px",
      },
    },
  },
  initial: {
    height: "2px",
    background: "#ccc",
    width: "33%",
  },
  Weak: {
    height: "2px",
    background: "red",
    width: "33%",
  },
  Medium: {
    height: "2px",
    background: "orange",
    width: "33%",
  },
  Strong: {
    height: "2px",
    background: "green",
    width: "33%",
  },
  strText: {
    fontWeight: "700",
  },
}));

export const ChangePasswordPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [stength, setStength] = useState({ strength: "initial" });
  const [isPasswordValidate, setPasswordValidate] = useState({
    currentPassword: false,
    newPassword: false,
  });

  const handleChange = () => {
    const token = localStorage.getItem("ACCESS_TOKEN");
    setErrors({});
    const errors = {};
    if (!currentPassword) {
      errors["currentPassword"] = "Password Should Not Be Empty";
    }
    if (!(password === rePassword)) {
      errors["rePassword"] = "Password Does Not Match";
    }
    if (!SPECIAL_CHARACTER.test(password)) {
      errors["password"] = "Password Should Contain Special Character";
    }
    if (!ATLEAST_ONE_UPPERCASE.test(password)) {
      errors["password"] = "Password Should Contain Atleast One Upper Case Character";
    }
    if (!(password.length >= MIN_PASS_CHAR_COUNT && password.length <= MAX_PASS_CHAR_COUNT)) {
      errors["password"] = "Password should contain 8-20 characters";
    }
    if (!password) {
      errors["password"] = "Please enter Password";
    }
    if (!rePassword) {
      errors["rePassword"] = "Please Re-Enter Your Password";
    }
    if (password === currentPassword) {
      errors["password"] = "New Password Should Not Be Same As Old Password";
    }
    setErrors(errors);
    if (Object.keys(errors).length > 0) {
      return;
    }
    setLoading(true);
    api
      .post("/auth/set-pass/", {
        token: token,
        password: password,
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success) {
            navigate(PAGES.emailSuccess, { replace: true });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  const handleChanges = (v) => {
    setPassword(v);
    if (
      SPECIAL_CHARACTER.test(v) &&
      ATLEAST_ONE_UPPERCASE.test(v) &&
      v.length >= MIN_PASS_CHAR_COUNT &&
      v.length <= MAX_PASS_CHAR_COUNT
    ) {
      setStength({ strength: "Strong" });
      setPasswordValidate({ ...isPasswordValidate, newPassword: true });
    } else if ((ATLEAST_ONE_UPPERCASE.test(v) || SPECIAL_CHARACTER.test(v)) && v.length >= 6) {
      setStength({ strength: "Medium" });
    } else if (v.length >= 1) {
      setStength({ strength: "Weak" });
    } else ({ strength: "initial" });
  };

  const handleCurrentPassword = (v) => {
    const token = localStorage.getItem("ACCESS_TOKEN");
    setErrors({});
    setCurrentPassword(v);
    api
      .post("/auth/validate-pass/", {
        token: token,
        password: v,
      })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success) {
            setPasswordValidate({
              ...isPasswordValidate,
              currentPassword: true,
            });
            setErrors({});
          }
          if (res.data.error) {
            setErrors({ currentPassword: res.data.error });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className={classes.root}>
      <div className={classes.logo}>
        <LogoText />
      </div>
      <Divider />

      <Typography className={classes.title} variant="h4" align="center">
        Change Password
      </Typography>
      <Container maxWidth="xs">
        <Grid container direction="column">
          <Grid alignItems="center"></Grid>
          <div style={{ display: "flex" }}>
            <div style={{ width: "100%" }}>
              <div className={classes.youremail}>
                <InputLabel className={classes.inputLabel}>Your current password:</InputLabel>
              </div>
              <div className={classes.passwordwithforget}>
                <TextInput
                  id="password-input"
                  type="password"
                  placeHolder=""
                  onChange={(v) => handleCurrentPassword(v)}
                  value={currentPassword}
                  error={errors.currentPassword}
                  rootStyle={classes.input}
                  onFocus={() => setErrors({ ...errors, currentPassword: null })}
                  startAdornment={<img src={lockIcon} alt="lock-icon" />}
                />
              </div>

              <div className={classes.youremail}>
                <InputLabel className={classes.inputLabel}>New password:</InputLabel>
              </div>
              <TextInput
                id="password-input"
                type="password"
                fullWidth
                placeHolder="password"
                onChange={(v) => handleChanges(v)}
                value={password}
                error={errors.password}
                rootStyle={classes.input}
                onFocus={() => setErrors({ ...errors, password: null })}
                startAdornment={<img src={lockIcon} alt="lock-icon" />}
              />
              {password && (
                <div style={{ display: "flex", width: "70%", margin: "auto" }}>
                  {stength.strength == "Weak" && (
                    <>
                      <div className={classes.Weak}></div>
                      <div className={classes.initial}></div>
                      <div className={classes.initial}></div>
                    </>
                  )}
                  {stength.strength == "Medium" && (
                    <>
                      <div className={classes.Medium}></div>
                      <div className={classes.Medium}></div>
                      <div className={classes.initial}></div>
                    </>
                  )}
                  {stength.strength == "Strong" && (
                    <>
                      <div className={classes.Strong}></div>
                      <div className={classes.Strong}></div>
                      <div className={classes.Strong}></div>
                    </>
                  )}
                </div>
              )}
              {password && (
                <div style={{ width: "70%", margin: "auto" }}>
                  <span>password strength : </span>
                  <span
                    className={classes.strText}
                    style={
                      stength.strength == "Weak"
                        ? { color: "red" }
                        : stength.strength == "Medium"
                        ? { color: "orange" }
                        : { color: "green" }
                    }
                  >
                    {stength.strength}
                  </span>
                </div>
              )}

              <div style={{ marginTop: "35px" }}>
                <TextInput
                  id="password-input"
                  type="password"
                  fullWidth
                  placeHolder="Confirm new password"
                  onChange={(v) => setRePassword(v)}
                  value={rePassword}
                  error={errors.rePassword}
                  rootStyle={classes.input}
                  onFocus={() => setErrors({ ...errors, rePassword: null })}
                  startAdornment={<img src={lockIcon} alt="lock-icon" />}
                />
              </div>
            </div>
            <div>
              <TextButton
                text={"Forgot password?"}
                style={{
                  position: "absolute",
                  marginTop: "40px",
                  marginLeft: "-50px",
                }}
                onClick={() => navigate(PAGES.forgetPassword)}
              />
            </div>
          </div>

          <Grid
            className={classes.groupBtn}
            container
            justifyContent="space-evenly"
            alignItems="center"
          >
            <Button
              id="reset-password"
              rootStyle={classes.loginBtn}
              text="CHANGE PASSWORD"
              loading={loading}
              onClick={handleChange}
              disabled={
                !(
                  isPasswordValidate.currentPassword &&
                  isPasswordValidate.newPassword &&
                  password === rePassword
                )
              }
            />
          </Grid>
        </Grid>
      </Container>
      <div>
        <div className={classes.resetImgstyle}>
          <img src={ResetPasswordImg} alt="" />
        </div>
        <div>
          <FooterReset />
        </div>
      </div>
    </div>
  );
};
